
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingProduct=(params)=>get('/api/v1/product/paging',params)
export const detailProduct=(query)=>getOne(`/api/v1/product/detail/${query}`)
export const updateProduct=(body)=>put(`/api/v1/product/update`,body)
export const createProduct=(body)=>post(`/api/v1/product/create`,body)
export const deleteProduct=(body)=>destroy(`/api/v1/product/delete`,body)
